import { handleActions } from 'redux-actions';
import { mapReducersFromConfigurations } from '../../helpers/reducer';
import { configurations } from './configurations';

export const initialState = {
  isFetching: false,
  keys: []
};

const reducer = handleActions(
  mapReducersFromConfigurations('apiKey')(configurations), {
    ...initialState
  });

export default reducer;



// WEBPACK FOOTER //
// ./src/state/modules/api-key/reducers.js